<script>
    import vSelect from 'vue-select'

    export default {
        props: {},
        components: {'v-select': vSelect},
        data() {
            return {
                municipalities: [],
                city_search: '',
            }
        },
        watch: {
            city_search(val) {
                if (!_.isObject(val)) {
                    this.searchCoursesByCity()
                }
            }
        },
        mounted() {
            let self = this;
            document.addEventListener('DOMContentLoaded', function (event) {
                $('#city-select').change(function (e) {
                    setTimeout(function () {
                        self.searchCoursesByCity()
                    }, 200);
                });
            });

            this.$bus.$on('update-search-city', ({city}) => {
                this.$set(this, 'city_search', city)
            })
        },
        methods: {
            onSearchCity(search, loading) {
                this.searchCity(loading, search, this);
            },
            searchCity: _.debounce((loading, search, vm) => {
                axios({
                    method: 'get',
                    url: `/municipalities?term=${search}&promoted=1`
                }).then((response) => {
                    vm.municipalities = response.data.municipalities;
                    loading(false);
                }).catch((error) => {
                    this.message = 'Error';
                    loading(false);
                });
            }),
            searchCoursesByCity() {
                var self = this;
                this.$bus.$emit('filter_by_city', self.city_search)
            },
            changeRoute(a) {
                if (typeof a.name != 'undefined')
                    window.history.replaceState("", "", this.setUrlParameter(window.location.href, "city", a.name));
            },
            setUrlParameter(url, key, value) {
                var key = encodeURIComponent(key),
                    value = encodeURIComponent(value);

                var baseUrl = url.split('?')[0],
                    newParam = key + '=' + value,
                    params = '?' + newParam;
                let urlQueryString = '';

                if (url.split('?')[1] === undefined) { // if there are no query strings, make urlQueryString empty
                    urlQueryString = '';
                } else {
                    urlQueryString = '?' + url.split('?')[1];
                }

                // If the "search" string exists, then build params from it
                if (urlQueryString) {
                    var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
                    var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

                    if (value === undefined || value === null || value === '') { // Remove param if value is empty
                        params = urlQueryString.replace(removeRegex, "$1");
                        params = params.replace(/[&;]$/, "");

                    } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
                        params = urlQueryString.replace(updateRegex, "$1" + newParam);

                    } else if (urlQueryString == '') { // If there are no query strings
                        params = '?' + newParam;
                    } else { // Otherwise, add it to end of query string
                        params = urlQueryString + '&' + newParam;
                    }
                }

                // no parameter was set so we don't need the question mark
                params = params === '?' ? '' : params;

                return baseUrl + params;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/InvitationCourseForm.vue